import React, { ButtonHTMLAttributes, ReactNode } from "react";
import "./Button.css";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "outline" | "ghost";
  size?: "sm" | "md" | "lg";
  loading?: boolean;
  leftIcon?: ReactNode;
  rightIcon?: ReactNode;
  fullWidth?: boolean;
  children: ReactNode;
}

export const Button: React.FC<ButtonProps> = ({
  variant = "primary",
  size = "md",
  loading = false,
  leftIcon,
  rightIcon,
  fullWidth = false,
  children,
  className = "",
  disabled,
  ...props
}) => {
  const baseClasses = "button";
  const variantClasses = `button--${variant}`;
  const sizeClasses = `button--${size}`;
  const fullWidthClasses = fullWidth ? "button--full-width" : "";
  const loadingClasses = loading ? "button--loading" : "";

  const combinedClasses = [
    baseClasses,
    variantClasses,
    sizeClasses,
    fullWidthClasses,
    loadingClasses,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      className={combinedClasses}
      disabled={disabled || loading}
      {...props}
    >
      {loading && (
        <span className="button__spinner">
          <i className="fas fa-spinner fa-spin"></i>
        </span>
      )}

      {leftIcon && !loading && (
        <span className="button__icon button__icon--left">{leftIcon}</span>
      )}

      <span className="button__content">{children}</span>

      {rightIcon && !loading && (
        <span className="button__icon button__icon--right">{rightIcon}</span>
      )}
    </button>
  );
};

export default Button;
